const canUseDOM = Boolean(
  // Copy React's method of detecting SSR or browser environment
  typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement,
);

export default canUseDOM;
